import React from 'react';
import { FiSearch, FiImage, FiSettings } from 'react-icons/fi';

const SearchBar = ({
  query,
  setQuery,
  onSearch,
  onImageSearch,
  showFilters,
  setShowFilters
}) => {
  const handleImageSearch = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    onImageSearch(file);
    e.target.value = '';
  };

  const iconStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#5f6368',
    cursor: 'pointer',
    padding: '4px',
    transition: 'color 0.2s ease',
  };

  const buttonResetStyle = {
    border: 'none',
    background: 'transparent',
    padding: 0,
    margin: 0,
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '20px 0 12px 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '460px',
          }}
        >
          <input
            type="text"
            placeholder="Введите запрос..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            style={{
              width: '100%',
              padding: '12px 92px 12px 18px',
              borderRadius: '28px',
              border: '1px solid #d9d9d9',
              outline: 'none',
              fontSize: '16px',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
            }}
          />

          <div
            style={{
              position: 'absolute',
              right: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <label
              style={iconStyle}
              title="Поиск по изображению"
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#004DCF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5f6368';
              }}
            >
              <FiImage size={20} />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageSearch}
                style={{ display: 'none' }}
              />
            </label>

            <button
              onClick={onSearch}
              style={{
                ...iconStyle,
                ...buttonResetStyle,
              }}
              title="Поиск"
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#004DCF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5f6368';
              }}
            >
              <FiSearch size={20} />
            </button>
          </div>
        </div>

        <button
          type="button"
          onClick={() => setShowFilters((prev) => !prev)}
          title={showFilters ? 'Скрыть фильтры' : 'Показать фильтры'}
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            border: 'none',
            background: showFilters ? '#eef5ff' : 'transparent',
            color: showFilters ? '#004DCF' : '#5f6368',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#eef5ff';
            e.currentTarget.style.color = '#004DCF';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = showFilters ? '#eef5ff' : 'transparent';
            e.currentTarget.style.color = showFilters ? '#004DCF' : '#5f6368';
          }}
        >
          <FiSettings size={20} />
        </button>
      </div>
    </div>
  );
};

export default SearchBar;